import { Controller } from "@hotwired/stimulus"

// Optional fields folded under "+ Name" links (the text panel's title and
// author). A click opens a field for good: there is no way to fold it again,
// and a blank one is sent blank and ignored by the server.
//
// Field and link pair up by data-name.
export default class extends Controller {
  static targets = [ "row", "field", "link" ]

  open({ params: { name } }) {
    const field = this.fieldFor(name)
    if (!field) return

    field.hidden = false
    this.linkFor(name).hidden = true
    this.sync()
    field.querySelector("input")?.focus()
  }

  // A send that keeps the page (the native outbox resets the form instead of
  // replacing it) folds the fields again. The reset event fires before the
  // values clear; a field edited during the send keeps its text and stays.
  formReset(event) {
    if (!(event.target instanceof HTMLFormElement) || !event.target.contains(this.element)) return

    setTimeout(() => {
      for (const field of this.fieldTargets) {
        if (field.querySelector("input")?.value.trim()) continue

        field.hidden = true
        this.linkFor(field.dataset.name).hidden = false
      }
      this.sync()
    })
  }

  // With a field open the row turns into columns (see _text_panel.html.erb).
  sync() {
    this.rowTarget.toggleAttribute("data-expanded", this.fieldTargets.some((field) => !field.hidden))
  }

  fieldFor(name) {
    return this.fieldTargets.find((field) => field.dataset.name === name)
  }

  linkFor(name) {
    return this.linkTargets.find((link) => link.dataset.name === name)
  }
}
